var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendRequestIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bulk_Arrow_-_Right_Square",
    "data-name": "Iconly/Bulk/Arrow - Right Square",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_-_Right_Square",
    "data-name": "Arrow - Right Square",
    transform: "translate(0 34) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M0,10.057V23.943C0,29.959,3.869,34,9.631,34H24.37C30.131,34,34,29.959,34,23.943V10.057C34,4.043,30.129,0,24.368,0H9.631C3.869,0,0,4.043,0,10.057",
    fill: "#93a750",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M.371,9.668l6.372,6.4a1.314,1.314,0,0,0,1.809,0l6.372-6.4a1.276,1.276,0,0,0-1.809-1.8L8.921,12.078V1.275a1.275,1.275,0,0,0-2.55,0v10.8L2.178,7.868a1.275,1.275,0,0,0-1.807,1.8",
    transform: "translate(9.354 8.786)",
    fill: "#93a750"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendRequestIcon);
export default __webpack_public_path__ + "static/media/SendRequestIcon.7792e88c3ec01451fcaf4d0be5d25f65.svg";
export { ForwardRef as ReactComponent };